export const printVisa = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-visa-status/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch visa status');
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/pdf')) {

      const contentDisposition = response.headers.get('content-disposition');
      const filename = contentDisposition
        ? contentDisposition.split('filename=')[1].replace(/['"]/g, '')
        : 'visa-status.pdf';

      const blob = await response.blob();
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      
      document.body.appendChild(link);
      link.click();
      
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
      
      return true;
    } else {
      const data = await response.json();
      throw new Error(data.error || 'Invalid response format');
    }
  } catch (error) {
    console.error('Error downloading visa:', error);
    throw error;
  }
};

export const checkBatch = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-batch-status/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to check batch');
    }

    // Check if the response is a PDF file
  } catch (error) {
    console.error('Error downloading visa:', error);
    throw error;
  }
};

export const checkVisa = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-application-status/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to check visa');
    }

    // Check if the response is a PDF file
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const checkVisaStatus = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-visa-abilities-status/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to check visa');
    }

    // Check if the response is a PDF file
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkCarrerStatus = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-career-exam-for-client/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to check career status');
    }

    // Check if the response is a PDF file
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkHos = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-hos-status/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to check visa');
    }

    // Check if the response is a PDF file
  } catch (error) {
    console.error(error);
    throw error;
  }
};



export const checkBatchHosFun = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-batch-hos/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to check batch');
    }

    // Check if the response is a PDF file
  } catch (error) {
    console.error('Error downloading visa:', error);
    throw error;
  }
};

export const checkBatchVisaFun = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-batch-visa-abilities-status/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.log(errorData);
      throw new Error(errorData.error || 'Failed to check batch');
    }

    // Check if the response is a PDF file
  } catch (error) {
    console.error('Error downloading visa:', error);
    throw error;
  }
};

export const checkBatchCarrerFun = async (id) => {
  try {
    const response = await fetch(`/api/v1/checks/check-career-exam-for-batch/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.log(errorData);
      throw new Error(errorData.error || 'Failed to check batch');
    }

    // Check if the response is a PDF file
  } catch (error) {
    console.error('Error downloading visa:', error);
    throw error;
  }
};